import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <h1 className="text-2xl font-bold bg-gradient-to-r from-[#00ff41] to-[#ff6b35] bg-clip-text text-transparent">
              ALEX MORGAN
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('content')}
              className="text-gray-300 hover:text-[#00ff41] transition-colors duration-200 font-medium"
            >
              Content
            </button>
            <button
              onClick={() => scrollToSection('brands')}
              className="text-gray-300 hover:text-[#00ff41] transition-colors duration-200 font-medium"
            >
              Brands
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-300 hover:text-[#00ff41] transition-colors duration-200 font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-gray-300 hover:text-[#00ff41] transition-colors duration-200 font-medium"
            >
              Results
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-300 hover:text-[#00ff41] transition-colors duration-200 font-medium"
            >
              About
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#00ff41] text-black hover:bg-[#00ff41]/90 font-bold px-6"
            >
              Work With Me
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/98 backdrop-blur-sm border-t border-gray-800">
          <div className="px-4 pt-4 pb-6 space-y-4">
            <button
              onClick={() => scrollToSection('content')}
              className="block w-full text-left text-gray-300 hover:text-[#00ff41] transition-colors py-2 font-medium"
            >
              Content
            </button>
            <button
              onClick={() => scrollToSection('brands')}
              className="block w-full text-left text-gray-300 hover:text-[#00ff41] transition-colors py-2 font-medium"
            >
              Brands
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-gray-300 hover:text-[#00ff41] transition-colors py-2 font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left text-gray-300 hover:text-[#00ff41] transition-colors py-2 font-medium"
            >
              Results
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-gray-300 hover:text-[#00ff41] transition-colors py-2 font-medium"
            >
              About
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-[#00ff41] text-black hover:bg-[#00ff41]/90 font-bold"
            >
              Work With Me
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
